<input type="hidden" [id]="id" [value]="getValue()" name="value">